import React from 'react';
import PropTypes from 'prop-types';
import './BillSummaryGrid.css';
import PrintBillingSummaryButton from './PrintBillingSummaryButton';

const fmtMoney = (n) =>
  Number(n || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const BillingSummaryGrid = ({ rows = [], electronicTotal }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <div className="billing-grid">
      <div className="grid-header-bar">
        <div className="grid-title">
          RESUMEN DE VENTAS BRUTAS POR TIPO DE COMPROBANTE
        </div>

        <PrintBillingSummaryButton billSummary={{ rows, electronicTotal }} />
      </div>

      <div className="grid-wrapper">
        <table className="billing-table">
          <thead>
            <tr className="grid-header">
              <th className="cell code">N°</th>
              <th className="cell desc">DESCRIPCIÓN</th>
              <th className="cell num">EXONERADO</th>
              <th className="cell num">
                BASE IMPONIBLE DE LA OPERACION GRAVADA
              </th>
              <th className="cell num">IGV</th>
              <th className="cell num">
                IMPORTE TOTAL DE LA OPERACION GRAVADA
              </th>
              <th className="cell num">TOTAL VENTA</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r, idx) => (
              <tr
                className={`grid-body ${idx % 2 === 1 ? 'alt' : ''}`}
                key={`${r.documentCode}-${r.description}`}
              >
                <td className="cell code">{r.documentCode}</td>
                <td className="cell desc">{r.description}</td>
                <td className="cell num">{fmtMoney(r.exemptAmount)}</td>
                <td className="cell num">{fmtMoney(r.taxableAmount)}</td>
                <td className="cell num">{fmtMoney(r.taxAmount)}</td>
                <td className="cell num">{fmtMoney(r.netAmount)}</td>
                <td className="cell num">{fmtMoney(r.totalAmount)}</td>
              </tr>
            ))}

            {electronicTotal && (
              <tr className="grid-total">
                <td className="cell code">{electronicTotal.documentCode}</td>
                <td className="cell desc">{electronicTotal.description}</td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.exemptAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.taxableAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.taxAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.netAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.totalAmount)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

BillingSummaryGrid.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      documentCode: PropTypes.string,
      description: PropTypes.string,
      exemptAmount: PropTypes.number,
      taxableAmount: PropTypes.number,
      taxAmount: PropTypes.number,
      netAmount: PropTypes.number,
      totalAmount: PropTypes.number,
    }),
  ),
  electronicTotal: PropTypes.shape({
    documentCode: PropTypes.string,
    description: PropTypes.string,
    exemptAmount: PropTypes.number,
    taxableAmount: PropTypes.number,
    taxAmount: PropTypes.number,
    netAmount: PropTypes.number,
    totalAmount: PropTypes.number,
  }),
};

BillingSummaryGrid.defaultProps = {
  rows: [],
  electronicTotal: null,
};

export default BillingSummaryGrid;
